
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'rui-card-border',
  props: {
    bodyMaxHeight: String,
  },
});
